import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IPAnalysisDrawerService {
    private _isOpen$ = new BehaviorSubject<boolean>(false);
    private _currentIP$ = new BehaviorSubject<string | null>(null);

    /**
     * Observable for drawer open/close state
     */
    get isOpen$(): Observable<boolean> {
        return this._isOpen$.asObservable();
    }

    /**
     * Observable for current IP being analyzed
     */
    get currentIP$(): Observable<string | null> {
        return this._currentIP$.asObservable();
    }

    /**
     * Get current drawer state
     */
    get isOpen(): boolean {
        return this._isOpen$.value;
    }

    /**
     * Get current IP value
     */
    get currentIP(): string | null {
        return this._currentIP$.value;
    }

    /**
     * Open drawer and analyze IP
     * @param ip IP address to analyze
     */
    openDrawer(ip: string): void {
        console.log('🔓 IPAnalysisDrawerService: Opening drawer for IP:', ip);
        this._currentIP$.next(ip);
        this._isOpen$.next(true);
    }

    /**
     * Close drawer
     */
    closeDrawer(): void {
        console.log('🔒 IPAnalysisDrawerService: Closing drawer');
        this._isOpen$.next(false);
        // Keep IP value for a moment to allow smooth transition
        setTimeout(() => {
            this._currentIP$.next(null);
        }, 300);
    }

    /**
     * Toggle drawer state
     */
    toggleDrawer(): void {
        if (this._isOpen$.value) {
            this.closeDrawer();
        }
    }
}
